
import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import {
  Col, Row, Input, InputNumber, Select, Radio,
} from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { 
  BACKEND_URL_QUOTATION,
  BACKEND_URL_SOFTSEGUROS_MARCA_LICENCIA
} from 'Config/routes';
// --------------------------------- --------------------------------- --------------------------------- ---------------------------------
export const CommonLayout = ({ children }) => (
  <Row type="flex" justify="center" style={{ margin: '0px 0px 45px', padding: '60px 0 0 0' }}>
    <Col xs={22} sm={16} md={14} lg={10} xl={10}>
      {children}
    </Col>
  </Row>
);
CommonLayout.propTypes = {
  children: PropTypes.any.isRequired,
};

// --------------------------------- --------------------------------- --------------------------------- ---------------------------------
export const TextField = (props) => (
  <Input
    size="large"
    // style={{ padding: '10px' }}
    {...props}
  />
);

// --------------------------------- --------------------------------- --------------------------------- ---------------------------------
export const MoneyField = (props) => (
  <InputNumber
    size="large"
    formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
    parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
    style={{ width: '100%' }}
    {...props}
  />
);

// --------------------------------- --------------------------------- --------------------------------- ---------------------------------
export const CommonLabel = ({ children }) => (
  <h3 style={{
    textAlign: 'center',
    fontSize: '22px',
    color: '#313131',
    margin: '0 0 25px',
  }}
  >
    {children}
  </h3>
);
CommonLabel.propTypes = { children: PropTypes.any.isRequired };

// --------------------------------- --------------------------------- --------------------------------- ---------------------------------
export class SelectAjax extends React.Component {
  constructor(props) {
    super(props);

    this.timeout = null;
    this.state = {
      fetching: false,
      data: [],
    };
  }

  componentDidMount() {
    const { initialData, disabled } = this.props;

    if (initialData.length) {
      this.setState((prevState) => ({
        ...prevState,
        data: initialData,
      }));
    }

    if (disabled) return; // No ejecuta la consulta si el select esta deshabilitado

    this.handdleOnSearch(''); // Si no envían un initial data, filtrar los primeros registros
  }

  handdleOnSearch(textSearch) {
    const {
      serializeResponse,
      serializeParams,
      urlRequest,
      handdleOnSearch,
    } = this.props;

    if (handdleOnSearch) handdleOnSearch(textSearch);

    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
      // return;
    }

    this.timeout = setTimeout(() => {
      this.setState((state) => ({
        ...state,
        fetching: true,
        data: [],
      }));

      axios.get(urlRequest, {
        params: serializeParams(textSearch),
        headers: {
          Authorization: `Token ${localStorage.getItem('token')}`,
        },
      }).then((response) => {
        const serializedData = serializeResponse(response.data);
        this.setState((state) => ({
          ...state,
          fetching: false,
          data: serializedData,
        }));
      });
    }, 800);
  }

  handdleChange(selectedValue) {
    const { data } = this.state;
    const { onChange } = this.props;

    // Filtrar el registro acabado de seleccionar.
    const selectedItem = data.find((item) => item.value === selectedValue);

    // Si envían un OnChange desde el padre, ejecutarlo enviando el item seleccionado.
    onChange(selectedItem);
  }

  render() {
    const { data } = this.state;
    const {
      value,
      placeholder,
    } = this.props;

    return (
      <Select
        size="large"
        value={value || undefined} // Se hace así para que muestre el placeholder
        showSearch
        defaultActiveFirstOption={false}
        // showArrow
        // filterOption={(op) => op.toUpperCase()}
        onSearch={(textSearch) => this.handdleOnSearch(textSearch)}
        onChange={(selectedValue) => this.handdleChange(selectedValue)}
        // onBlur={() => input.onBlur(input.value)}
        // notFoundContent={null}
        filterOption={false}
        className={this.props.className}
        placeholder={placeholder}
        onBlur={this.props.onBlur}
        notFoundContent={<div>No se encontraron registros</div>}
        style={{ width: '100%' }}
        disabled={this.props.disabled}
      >
        {data.map((item) => (
          <Select.Option key={item.value} value={item.value}>{item.label}</Select.Option>
        ))}
      </Select>
    );
  }
}

SelectAjax.defaultProps = {
  onChange: () => { },
  handdleOnSearch: () => { },
  initialData: [],
  value: null,
  placeholder: '',
};

SelectAjax.propTypes = {
  serializeResponse: PropTypes.func.isRequired,
  serializeParams: PropTypes.func.isRequired,
  urlRequest: PropTypes.string.isRequired,
  value: PropTypes.any,

  onChange: PropTypes.func,
  handdleOnSearch: PropTypes.func,
  initialData: PropTypes.array,
  placeholder: PropTypes.string,
};


const notFoundModel = <div>No se encontraron registros</div>;

// --------------------------------- --------------------------------- --------------------------------- ---------------------------------
export const SimpleSelect = ({ options, ...props }) => (
  <Select
    size="large"
    style={{ width: '100%' }}
    showSearch
    notFoundContent={notFoundModel}
    {...props}
  >
    {options.map((item) => (
      <Select.Option key={item.value} value={item.value}>{item.label}</Select.Option>
    ))}
  </Select>
);
SimpleSelect.propTypes = { options: PropTypes.array.isRequired };


// --------------------------------- --------------------------------- --------------------------------- ---------------------------------
export const RadioButtonField = ({ aling, options, ...props }) => (
  <Radio.Group
    {...props}
    style={{ display: 'flex', justifyContent: aling }}
  >
    {options.map((item) => <Radio.Button key={item.value} value={item.value} style={{ zIndex: 0 }}>{item.label}</Radio.Button>)}
  </Radio.Group>
);
RadioButtonField.propTypes = { options: PropTypes.array.isRequired, aling: PropTypes.any.isRequired };


export const useBackNavigator = (props) => {
  const navigate = useNavigate();

  const back = (backTo) => {
    if (backTo) navigate(backTo);
    else navigate(-1);
  };

  const Navigator = ({ backTo }) => {
    return (
      <div style={{ left: '80px', position: 'absolute', cursor: 'pointer' }} onClick={() => back(backTo)} aria-hidden="true">
        <FontAwesomeIcon style={{ fontSize: '5em', color: 'rgba(0, 0, 0, 0.38)' }}
          icon={faChevronLeft}
        />
      </div>
    );
  };

  return {
    Navigator,
  };
};


export const getBalance = () => (
  axios.get(`${BACKEND_URL_SOFTSEGUROS_MARCA_LICENCIA}get_balance/`, {
    headers: {
      Authorization: `Token ${localStorage.getItem('token')}`,
    },
  }).then((response) =>{
    return response.data.saldo;
  })
);


export const getQuotationPrice = (reQuotation) => (
  axios.get(`${BACKEND_URL_QUOTATION}get_price/`, {
    params: {
      re_quotation: reQuotation
    },
    headers: {
      Authorization: `Token ${localStorage.getItem('token')}`,
    },
  }).then((response) => {
    return response.data.price;
  })
);
